import React from "react";
// import ReactTooltip from "react-tooltip";
// import { v4 as uuid } from "uuid";
import { ChronosDate } from "../_helpers";
import { Icon } from "../_components";
// import { useMaps, useApp } from "../_contexts";
import { useContextMenu } from "react-contexify";
// import { useSelector } from "react-redux";

export function TimelineEvent({
  events,
  calendar,
  step,
  laneStart,
  laneEnd,
  laneID,
  granularity,
  parentRef,
  timeline,
  getDate,
  chronicle,
  openPopup,
  closePopup,
  openSidebar,
  closeSidebar,
  isEditMode,
  maps,
  markers,
  goTo,
  goToMap,
  currentMap,
  getCurrentMap,
  handleClick,
}) {
  // const { items: maps } = useSelector((state) => state.maps);
  // const { items: markers } = useSelector((state) => state.markers);
  // console.group(`Event: "${events[0].title}",`, step);
  // ReactTooltip.rebuild();
  // console.log("TimelineEventRender", timeline, events);
  // const evUniqueID = uuid();
  const defaultBgColor = "rgba(200,0,0,0.5)";
  const defaultTextColor = "rgba(33,33,33,0.8)";
  let classes = ["chronicle-timeline-event"];
  let title = "";
  // console.log('Events', events[0]);
  let editMode = isEditMode;
  //Extract Context Values/Methods

  const { show } = useContextMenu({
    id: "chronos-event-context-menu",
    props: {},
  });

  //Begin Event Calculations
  const isBundle = events.length !== 1;
  const isRange =
    !isBundle &&
    events[0].toDate !== null &&
    events[0].overrideSpan === undefined
      ? true
      : false;
  const isSingle = !isBundle && !isRange;
  // if (isSingle) {
  //   console.log('Event is single', events);
  // }
  // if (isRange) {
  //   console.log('Event is ranged', events);
  // }
  // if (isBundle) {
  //   console.log('Event Bundled', events);
  // }
  const eventDate = new ChronosDate(events[0].fromDate, {
    calendar,
    // logSteps: step === 'day',
  });
  // console.log(events[0].title, eventDate.toFullObject());
  // let startX = eventDate.getPositionFromStart(laneStart, step);
  let startX = eventDate.getPositionRelativeToStart(laneStart, step);

  // console.log('Start Position (px): ', events[0].title, startX);
  let width = 15;

  if (startX < 0) {
    startX = 0; //adjust this if the event positions are offset to line up with UTD
  }

  if (isBundle) {
    classes.push("chronicle-timeline-event-bundle");
    title = `${events.length} Events`;
  }

  if (isRange) {
    // console.log(`Event calcs ${events[0].title}`);
    classes.push("chronicle-timeline-event-span");
    classes.push(`chronicle-event-${events[0]._id}`);
    title = events[0].title;

    switch (events[0].view) {
      case "END": {
        const EventEndDate = new ChronosDate(events[0].toDate, { calendar });
        width =
          EventEndDate.getPositionRelativeToStart(laneStart, granularity);
        startX = 0;
        break;
      }
      case "START": {
        const LaneEndDate = new ChronosDate(laneEnd, { calendar });
        width = LaneEndDate.getPositionRelativeToStart(
          events[0].fromDate,
          granularity
        );
        break;
      }
      case "SPAN": {
        width = "100%";
        startX = 0;
        break;
      }
      case "CONTAIN":
      default: {
        const EventEndDate = new ChronosDate(events[0].toDate, { calendar });

        width =
          EventEndDate.getPositionRelativeToStart(
            events[0].fromDate,
            granularity
          ); // +15
        break;
      }
    }
  }

  const styles = {
    left: isRange ? startX : startX, // - 0,
    width: width ? width : undefined,
    backgroundColor: "transparent",
  };

  if (isRange) {
    if (events[0].color && events[0].color !== "") {
      styles.backgroundColor = events[0].color;
    } else {
      styles.backgroundColor = defaultBgColor;
    }
  }

  if (isSingle) {
    classes.push(`chronos-event-${events[0]._id}`);
    title = events[0].title;
    if (events[0].color && events[0].color !== "") {
      styles.color = events[0].color;
    } else {
      styles.color = defaultTextColor;
    }
  }

  //Set Event Icon and importance CSS class
  let icon = "fas fa-circle";
  let importanceClass = "";
  let significance = false;

  switch (events[0].significance) {
    // Milestone / Era-Changing
    case 50: {
      icon = "fas fa-diamond";
      importanceClass = "chronos-event-milestone";
      significance = "Milestone";
      break;
    }
    // Major / Global
    case 40: {
      icon = "fas fa-square";
      importanceClass = "chronos-event-major";
      significance = "Major";
      break;
    }
    // Important / National
    case 30: {
      icon = "fas fa-circle";
      importanceClass = "chronos-event-important";
      significance = "Important";
      break;
    }
    // Minor / Regional
    case 20: {
      icon = "far fa-square";
      importanceClass = "chronos-event-minor";
      significance = "Minor";
      break;
    }
    // Trivial / Personal (Default)
    case 10: {
      icon = "far fa-circle";
      importanceClass = "chronos-event-insignificant";
      significance = "Trivial";
      break;
    }
    case 0:
    default: {
      icon = "far fa-circle";
      importanceClass = "chronos-event-default";
      significance = false;
      break;
    }
  }

  //Override icon if Event has a custom icon override
  if (isSingle && events[0].icon && events[0].icon !== "") {
    icon = events[0].icon;
  }

  // Event Handlers

  //Default method to reset components
  const resetUIComponents = () => {
    closeSidebar();
    closePopup();
  };

  //Handle BundledEvent Left Click
  const handleBundleClick = (ev) => {
    ev.preventDefault();
    //Reset Sidebar/Popup that might be open from a previous operation
    resetUIComponents();

    //Open the Sidebar with the EventBundle
    openSidebar({
      type: "bundle",
      payload: { bundle: events },
    });
  };

  //Handle Ranged or Single Event Left Click
  const handleEventClick = async (ev) => {
    console.log("Begin!");
    ev.preventDefault();

    //Reset Sidebar/Popup components
    resetUIComponents();
    //Open the Sidebar with the Event details
    openPopup({
      event: events[0],
      type: isSingle ? "event" : "range",
    });
    handleClick(events[0], isSingle ? "single" : isRange ? "range" : "bundle");
    //Check if Event has a Marker to navigate to
    // let { marker } = events[0];
    // if (marker && marker._id) {
    //   // const currentMap = getCurrentMap();
    //   const tempMarker = await markers.find((m) => m._id === marker._id);
    //   console.log("Marker Found: ", tempMarker, markers, marker._id);
    //   if (tempMarker) {
    //     const { parentMap, coords } = tempMarker;
    //     let map = await maps.find((m) => m._id === parentMap);
    //     const newCoords = {
    //       ...coords,
    //       z: map && map.options ? map.options.zoomMax : coords.z,
    //     };
    //     // console.log(`Event ${events[0].title} has a Marker!`, marker);
    //     if (currentMap._id !== parentMap) {
    //       //Navigate to Map and Coords of Marker
    //       console.log("Moving to new map", map, newCoords);
    //       await goToMap(parentMap, newCoords);
    //     } else {
    //       //Simply go to Coords on current Map
    //       console.log("Moving to coords", newCoords);
    //       await goTo(newCoords);
    //     }
    //   }
    // }
  };

  //Handle Context Click (Right Click)
  const handleContextClick = (ev) => {
    if (editMode) {
      ev.preventDefault();
      ev.stopPropagation();
      // console.log('Context Menu Triggered!', ev);
      if (!isBundle) {
        const { eventDate } = getDate(ev);

        const newEvent = {
          fromDate: eventDate, //replace with calculated startDate
          timeline,
          lane: laneID,
          chronicle,
        };

        //Trigger the EventContextMenu with props
        show(ev, {
          props: {
            eventItem: events[0],
            newEventItem: newEvent,
          },
        });
      }
    }
  };

  let eventTooltip =
    !isBundle && (events[0].eventType || significance)
      ? `<div class="chronos-event-tooltip">
          <p class="chronos-event-tooltip-title">${title}</p>
          <p class="chronos-event-tooltip-subtext">
          ${
            events[0].eventType && events[0].eventType.name
              ? `<span class="chronos-event-tooltip-type">${events[0].eventType.name}</span>`
              : ""
          } ${
          significance
            ? `<span class="chronos-event-tooltip-significance">${significance}</span>`
            : ""
        } </p></div>`
      : title;

  // console.log("TOOLTIP: ", eventTooltip);
  // console.groupEnd();

  return (
    <div
      className={classes.join(" ")}
      style={styles}
      data-tip={eventTooltip}
      data-for="chronos-event-tooltip"
      data-html={true}
      onContextMenu={handleContextClick}
    >
      {isBundle && (
        <div className="chronicle-event-bundle" onClick={handleBundleClick}>
          {events.length}
        </div>
      )}
      {isSingle && (
        <div className="chronicle-event-icon" onClick={handleEventClick}>
          <Icon icon={`${icon} ${importanceClass}`} />
        </div>
      )}
      {!isBundle && isRange && (
        <div className="chronicle-event-data" onClick={handleEventClick}>
          &nbsp;
        </div>
      )}
    </div>
  );
}
